import { A } from '@ember/array';
import EmberObject, { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { initializePropertyDefaults } from 'sh-www/utils/initialize-state-properties';
import { SH_PAYMENT } from "../../../../../models/sh-payment";

export default Service.extend({
  /**
   * Register Services
   */
  session: service(),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @type {Boolean}      True if a request to the server is in flight for invoice loading view.
     */
    isLoadingPayments: false,

    /**
     * This is the current filter object we will use when making our api calls for invoice loading.
     *
     * @return {Object}
     */
    currentFilter: () => EmberObject.create({}),

    /**
     * The current pagination for the invoices we are viewing.
     *
     * @return {Pagination}
     */
    currentPagination: () => EmberObject.create({}),

    /**
     * @type {Number}     Current page we are on in our state.
     */
    page: 1,

    /**
     * All query params for the payment search experience
     */
    paramApproved: undefined,
    paramAgreement: undefined,
    paramPaymentId: undefined,
    paramApplicationId: undefined,
    paramPaymentStatus: undefined,
    paramPayoneerAccountId: undefined,
    paramTransactionId: undefined,
    paramUserId: undefined,
    paramPaymentMethod: undefined,
    paramCompanyId: undefined,

    /**
     * @type {Ember.A<ShInvoice>}
     */
    shPayments: () => A()
  },

  queryParams: computed(
    'paramApproved',
    'paramAgreement',
    'paramPaymentId',
    'paramApplicationId',
    'paramPaymentStatus',
    'paramPayoneerAccountId',
    'paramTransactionId',
    'paramUserId',
    'paramCompanyId',
    'paramPaymentMethod',
    function () {
      const queryParams = {
        approved : this.paramApproved,
        agreement : this.paramAgreement,
        id : this.paramPaymentId,
        applicationId : this.paramApplicationId,
        paymentMethod : this.paramPaymentMethod,
        payoneerAccountId : this.paramPayoneerAccountId,
        transactionId : this.paramTransactionId,
        companyId: this.paramCompanyId,
        userId : this.paramUserId,
      };

      switch (this.paramPaymentStatus) {
        case SH_PAYMENT.STATUS.DUE:
          queryParams['due'] = '1';
          queryParams['paid'] = undefined;
          queryParams['error'] = undefined;
          break;
        case SH_PAYMENT.STATUS.PAID:
          queryParams['paid'] = '1';
          queryParams['due'] = undefined;
          queryParams['error'] = undefined;
          break;
        case SH_PAYMENT.STATUS.ERROR:
          queryParams['error'] = '1';
          queryParams['due'] = undefined;
          queryParams['paid'] = undefined;
          break;
        default:
          queryParams['error'] = undefined;
          queryParams['due'] = undefined;
          queryParams['paid'] = undefined;
          break;
      }

      return queryParams;
    }
  ),

  /**
   * @inheritDoc
   */
  init() {
    this._super(...arguments);
    initializePropertyDefaults(this);
  }
});
